import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export const gdprService = {
  async exportData() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/gdpr/export`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `user-data-export-${Date.now()}.json`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  async createExportRequest() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/gdpr/export`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.request as {
      id: string;
      type: 'EXPORT' | 'DELETE';
      status: string;
      requestedAt: string;
      processedAt?: string;
      fileName?: string;
    };
  },

  async listRequests() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/gdpr/requests`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data.requests as any[];
  },

  async downloadRequest(id: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/gdpr/download/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    });
    const cd = res.headers['content-disposition'] as string | undefined;
    const filenameMatch = cd && /filename="?([^";]+)"?/i.exec(cd);
    const filename = filenameMatch ? filenameMatch[1] : `user-data-export-${Date.now()}.json`;
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  async requestDeletion(password: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/gdpr/delete-request`, { password }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string; deletionDate: string };
  },

  async cancelDeletion() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/gdpr/delete-cancel`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string };
  },

  // Admin
  async adminListRequests(params?: { type?: string; status?: string }) {
    const token = localStorage.getItem('accessToken');
    const url = new URL(`${API_BASE_URL}/api/gdpr/admin/requests`);
    if (params?.type) url.searchParams.set('type', params.type);
    if (params?.status) url.searchParams.set('status', params.status);
    const res = await axios.get(url.toString(), { headers: { Authorization: `Bearer ${token}` } });
    return res.data.requests as any[];
  },

  async adminApproveDeletion(id: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/gdpr/admin/requests/${id}/approve`, {}, { headers: { Authorization: `Bearer ${token}` } });
    return res.data.request as any;
  },
};


